.
<template>
    <div id="today-event" class="calendar-today">
        <div @click="goCalendarPage">
            <div class="today-date-str">{{ getDayString() }}</div>
            <div class="today-date-number">{{ new Date().getDate() }}</div>
        </div>
        <a-popover id="calendarTodayEvents" placement="bottom" trigger="hover" overlayClassName="calendarTodayEvents">
            <template slot="content" v-if="todayEvents.length > 0">
                <div class="add-event-popover">
                    <div class="material-icons add-event-btn" @click="openAddEvent">add</div>
                    <div>Add Event</div>
                </div>
                <div class="calendar-event event-popover" v-for="todayEvent in todayEvents">
                    <div class="event-summary" @click="goCalendarPage(todayEvent)">{{ todayEvent.summary }}</div>
                    <div class="event-date" @click="goCalendarPage(todayEvent)">
                        <div>
                            {{ getEventTime(todayEvent.start, todayEvent.isAllDay) }} -
                            {{ getEventTime(todayEvent.end, todayEvent.isAllDay) }}
                        </div>
                    </div>
                </div>
            </template>
            <div class="">
                <div class="calendar-event header-event" v-if="todayEvents.length > 0">
                    <div class="event-summary" @click="goCalendarPage(todayEvents[0])">
                        {{ todayEvents[0].summary }}
                    </div>
                    <div class="event-date" @click="goCalendarPage(todayEvents[0])">
                        <div>
                            {{ getEventTime(todayEvents[0].start, todayEvents[0].isAllDay) }} -
                            {{ getEventTime(todayEvents[0].end, todayEvents[0].isAllDay) }}
                        </div>
                        <div class="" @click="goCalendarPage(todayEvents[0])" v-if="todayEvents.length > 1">
                            + {{ todayEvents.length }}
                        </div>
                        <div class="material-icons add-event-btn" @click="openAddEvent" v-else>add</div>
                    </div>
                </div>
                <div v-else>
                    <div class="material-icons add-event-btn" @click="openAddEvent">add</div>
                </div>
            </div>
        </a-popover>

        <CreateEventModal v-if="openCalendarAddEventModal" @close="openCalendarAddEventModal = false" />
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment-timezone";
import CONFIG from "../../../../config/config";
import CreateEventModal from "./CreateEventModal";
import _ from "lodash";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";

moment.locale("tr");
const log = log2("TodayEvent");
export default {
    name: "TodayEvent",
    components: {
        CreateEventModal,
    },
    props: {},
    data() {
        return {
            todayEvents: [],
            openCalendarAddEventModal: false,
            CONFIG,
            calendarSetting: {},
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            newEvent: (state) => state.calendar.newEvent,
            updatedEvent: (state) => state.calendar.updatedEvent,
            deleteEvent: (state) => state.calendar.deleteEvent,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            getTodayEvents: "calendar/getTodayEvents",
            getCalendarSettings: "calendar/getCalendarSettings",
        }),
        ...mapMutations({}),
        getSelectedTimezone() {
            return this.calendarSetting?.timezone || "Europe/Istanbul";
        },
        openAddEvent() {
            if (this.checkPermission(PERMISSION_TYPES["calendar.create"].tr.name)) {
                this.openCalendarAddEventModal = true;
            } else {
                this.$message.error("Bu işlem için izniniz yok");
            }
        },
        getEventTime(date, isAllDay) {
            console.log("getEventTime date", { date, isAllDay });
            if (isAllDay) return moment(date).format("L");
            else return moment(date).format("HH:mm");
        },
        getDayString() {
            return moment().format("dd");
        },
        goCalendarPage(event = null) {
            if (!!event) this.$router.push(`/calendar/d/${moment().format().split("T")[0]}/${event._id}`);
            else this.$router.push(`/calendar/d/${moment().format().split("T")[0]}`);
        },
    },
    async mounted() {
        this.$feature.beforeFetchCalendar(() => {
            this.getTodayEvents(this.user._id).then((res) => {
                console.log("getTodayEvents..", res);
                this.todayEvents = res;
            });
            this.getCalendarSettings({ userId: this.user._id }).then((res) => {
                this.calendarSetting = res;
            });
        });
    },
    watch: {
        deleteEvent(value) {
            console.log("today deleteEvent watch", value);
            if (this.todayEvents.find((event) => event._id === value._id)) {
                this.todayEvents = this.todayEvents.filter((event) => event._id !== value._id);
            }
        },
        newEvent(values) {
            console.log("TodayEvent newEvent", values);
            values = _.isArray(values) ? values : [values];
            const timezone = this.getSelectedTimezone();

            values.map((val) => {
                if (
                    (val &&
                        val.start >= moment().tz(timezone).format() &&
                        val.start <= moment().tz(timezone).endOf("day").format()) ||
                    (val.start <= moment().tz(timezone).format() && val.end >= moment().tz(timezone).format())
                ) {
                    let dates = [val, ...this.todayEvents];
                    dates.sort(function (a, b) {
                        return new Date(a.start) - new Date(b.start);
                    });
                    this.todayEvents = dates;
                }
            });
        },
        updatedEvent(values) {
            console.log("TodayEvent updatedEvent", values);
            const ids = this.todayEvents.map((event) => event._id);
            values = _.isArray(values) ? values : [values];
            const timezone = this.getSelectedTimezone();
            values.map((val) => {
                if (
                    (val &&
                        val.start >= moment().tz(timezone).format() &&
                        val.start <= moment().tz(timezone).endOf("day").format()) ||
                    (val.start <= moment().tz(timezone).format() && val.end >= moment().tz(timezone).format())
                ) {
                    console.log("today event if");
                    if (!ids.includes(val._id)) {
                        let dates = [val, ...this.todayEvents];
                        dates.sort(function (a, b) {
                            return new Date(a.start) - new Date(b.start);
                        });
                        this.todayEvents = dates;
                    }
                } else {
                    console.log("today event else ");
                    this.todayEvents = this.todayEvents.filter((event) => event._id !== val._id);
                }
            });
        },
    },
};
</script>

<style>
.calendarTodayEvents {
    .ant-popover-inner-content {
        padding: 0 !important;
        box-shadow: 0 3px 6px #00000080;
    }
}
</style>

<style lang="scss" scoped>
.event-date {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    margin-top: -3px;

    .add-event-btn {
        font-size: 20px;

        &:hover {
            color: #448aff;
        }
    }
}

.add-event-popover {
    border-bottom: 1px solid grey;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.calendar-event {
    width: 120px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.header-event {
        margin-left: 15px;
    }

    &.event-popover {
        padding: 5px 10px;
        width: 150px;
    }

    &:hover {
        background-color: #f3f3f3;
    }

    .event-summary {
        font-weight: 700;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: -2px;
    }
}

.calendar-today {
    height: 100% !important;
    display: flex;
    cursor: pointer;
    padding: 2px;
    border-radius: 8px;
    border: 1px solid var(--color-border-default);
    position: relative;

    .today-date-str {
        font-size: 15px;
        display: flex;
        justify-content: start;
    }

    .today-date-number {
        font-size: 16px;
        font-weight: 900;
        position: absolute;
        left: 4px;
        top: 16px;
    }
}

#today-event {
    height: 35px !important;
}
</style>
